import { COMPANIES, COMPANY_USERS, PRODUCTS, PURCHASE_ORDERS } from '@/legacy/mocks/seed';
import { useStore } from '@/legacy/store';
import type { B2BServices } from '../b2bContracts';

export const mockB2BServices: B2BServices = {
  async home() {
    const company = COMPANIES[0];
    const quotes = useStore.getState().quotes.map((q) => ({
      id: q.id, status: q.status, items: q.items.map((i) => ({ name: i.productName, qty: i.qty, price: i.requestedPrice })),
      totalAmount: q.totalAmount ?? 0, createdAt: q.createdAt,
      messages: (q.messages ?? []).map((m) => ({ senderName: m.senderName ?? 'Buyer', message: m.message ?? m.text ?? '', at: m.at })),
    }));
    return {
      company: { id: company.id, name: company.name, creditLimit: company.creditLimit, availableCredit: company.availableCredit, paymentTermsDays: company.paymentTermsDays },
      quotes,
      purchaseOrders: PURCHASE_ORDERS.map((p) => ({ id: p.id, poNumber: p.poNumber, status: p.status, totalAmount: p.totalAmount, itemCount: p.items.length, createdAt: p.submittedAt ?? p.createdAt })),
      requisitions: [],
    };
  },
  async catalog() {
    return PRODUCTS.map((p) => ({ id: p.id, name: p.name, sku: p.sku, price: p.price, stock: p.stock }));
  },
  async createRequisition() {},
  async createQuote() {},
  async quote(id) {
    const home = await this.home();
    const q = home.quotes.find((row) => row.id === id);
    if (!q) throw new Error('Quote not found');
    return q;
  },
  async quoteMessage() {},
  async quoteAction() {},
  async createPo(items) {
    return { id: 'local', poNumber: 'PO-LOCAL', status: 'draft', totalAmount: items.reduce((s, i) => s + i.price * i.qty, 0), itemCount: items.length, createdAt: new Date().toISOString() };
  },
  async convertPo() {},
  async credit() {
    const company = COMPANIES[0];
    return { creditLimit: company.creditLimit, availableCredit: company.availableCredit, paymentTermsDays: company.paymentTermsDays, transactions: [] };
  },
  async inviteUser() { return { temporaryPassword: 'demo123' }; },
  async users() {
    const company = COMPANIES[0];
    return {
      companyName: company.name,
      users: COMPANY_USERS.filter((u) => u.companyId === company.id).map((u) => ({
        id: u.id, name: u.name, email: u.email, role: u.role, maxPoValue: u.maxPoValue ?? null, status: u.status,
      })),
    };
  },
};
